<template>
    <modal color="success" size="lg"  :title="$t('desTranslation')" :loading="true" :show.sync="localShowModal" :footer="false" centered>
      <CCard>
        <CCardBody>
          <h5 class="text-dark mb-1">
            {{$t('desTranslation')}}
            <span class="text-info h5">
              <CIcon name="cil-language" color="info" />
            </span> 
          </h5>
          <!-- <p class="text-grey mb-0 mt-2">{{ $t('productDes') }}</p> -->
          <textarea
            v-model="defaultDescription"
            ref="defaultDescTextarea"
            class="form-control mb-2"
            rows="4"
            disabled
          ></textarea>

          <CRow >
            <!-- <div class="col-xl-3 col-lg-3 col-sm-4 col-6">
              <CButton block color="success" 
             
                @click="getTranslationAll()"
                @mouseover="isHovered = true"
                @mouseleave="isHovered = false" >
                  {{ isTranslating ? $t('translating') : $t('translateAll') }}
                  <img :src="isHovered ? '/img/languages/Ai_W.png' : '/img/languages/Ai_W.png'"
                  style="width: 20px; height: 20px;" />
            </CButton>
            </div> -->
            <div class="col-xl-12 col-lg-12 col-sm-12  col-12 text-left">
              <!-- <select v-model="newLanguage" @change="addLanguage" class="form-control" :disabled="availableLanguages.length <= 0">
                <option disabled value="">{{$t('addMoereDesTran')}}</option>
                <option v-for="lang in availableLanguages" :key="lang.value" :value="lang">
                  <img :src="lang.img" :alt="lang.name" class="lang-icon" /> {{ lang.name }}
                </option>
              </select> -->
              <Multiselect
                ref="langSelect"
                :options="availableLanguages"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :clear-on-select="true"
                track-by="value"
                label="name"
                :placeholder="$t('addMoereDesTran')"
                :disabled="availableLanguages.length <= 0"
                @input="onSelectLanguage"
              >
                <!-- รายการพร้อมธง -->
                <template #option="{ option }">
                  <div class="lang-option">
                    <img :src="option.img" :alt="option.name" class="lang-flag" />
                    <span>{{ option.name }}</span>
                  </div>
                </template>

                <!-- แสดงผลเมื่อเลือก -->
                <template #singleLabel="{ option }">
                  <div class="lang-option">
                    <img :src="option.img" :alt="option.name" class="lang-flag" />
                    <span>{{ option.name }}</span>
                  </div>
                </template>
              </Multiselect>
            </div>
          </CRow>
          <div v-if="translations.length > 0" class="card-body-background ">
            <hr  style="border-top-color: #29b289;" />
            <div class=" scrollable-translations">
            <div  v-for="(input, index) in translations" :key="index" class="row pl-2 pb-1">
              <img :src="input.img" :alt="input.name" class="col-form-label lang-icon" />
              <div class="col-lg-11 col-10" >
                <textarea
                  class="form-control mb-0 p-2 m-1 pt-0"
                  v-model="input.description"
                  :rows="4"
                  :ref="'descTextarea-' + index"
                  @input="autoResizeFromInput($event, index)"
                  :class="[input.isAnimating ? 'soft-blink' : 'no-blink']"
                  :readonly="input.isAnimating"
                  :disable="input.isAnimating"
                  :key="input.isAnimating + '-' + index"
                  :dir="isRTL(input.value) ? 'rtl' : 'ltr'"
                ></textarea>
                <div class="d-flex justify-content-between align-items-center ">
                <div class="custom-control custom-checkbox ml-2">
                  <input type="checkbox" class="custom-control-input" v-model="input.isTheSame" :id="'checkbox-des-' + index"
                    @change="handleCheckboxChange(input)" />
                  <label class="custom-control-label cursor" :for="'checkbox-des-' + index">
                    {{ $t('useDefault') }}
                  </label>
                </div>
                <!-- <div class="text-dark cursor-pointer cursor" @click="getTranslation(index)" :class="[input.loading ? 'soft-blink' : '','shake-on-hover']">
                  {{$t('translateByAI')}} <img src="/img/languages/Ai_G.png"  style="width: 20px; height: 20px;" />
                </div> -->
              </div>
              </div>
              <div @click="removeLanguage(index)" class="col-form-label cursor p-1">
                <img src="/img/trash.png" style="width: 16px; height: 16px; cursor: pointer;" />
              </div>

            </div>
          </div>
          </div>
          <div v-else  :class="['card-body-background' ,translations.length <= 0 ? 'light-background' : '']"> 
          <!-- <img src="/img/languages/a1.png" class="img-fluid pt-2" style="width: 100%; height: auto;" /> -->
        </div>
        </CCardBody>
      </CCard>
    </modal>
  </template>
  
  <script>
  import openrouter from '@/services/openrouterapi'
  import util from "@/util/util";
  import Multiselect from 'vue-multiselect';
  export default {
    props: {
      showModal: Boolean,
      defaultDescription: String,
      translations: {
        type: Array,
        required: false, // Make it optional
        default: () => [] // Ensure default is an empty array
      },
    },
    components: { Multiselect },
    data() {
      return {
        newLanguage: '',
        localShowModal: this.showModal,
        languages: [
          { value: 'th', name: 'ไทย', img: '/img/languages/th.png' },
          { value: 'en', name: 'English', img: '/img/languages/en.png' },
          { value: 'lo', name: 'ລາວ', img: '/img/languages/lo.png' },
          { value: 'my', name: 'မြန်မာ', img: '/img/languages/my.png' },
          { value: 'zh', name: 'Chinese', img: '/img/languages/flag_China01.png' },
          { value: 'ja', name: '日本語 (Japanese)', img: '/img/languages/flag_JP01.png' },
          { value: 'km', name: 'ភាសាខ្មែរ (Khmer)', img: '/img/languages/flag_Cambodia01.png' },
          { value: 'ko', name: '한국어', img: '/img/languages/ko.png' },
          { value: 'hi', name: 'हिन्दी (India)', img: '/img/languages/flag_India01.png' },
          { value: 'id', name: 'Bahasa Indonesia', img: '/img/languages/flag_Indo01.png' },
          { value: 'ar', name: 'العربية', img: '/img/languages/flag_Arab01.png' }
          // { value: 'ja', name: '日本語', img: '/img/languages/ja.png' },
          // { value: 'vi', name: 'Tiếng Việt', img: '/img/languages/vi.png' },
          // { value: 'fr', name: 'Français', img: '/img/languages/fr.png' },
          // { value: 'de', name: 'Deutsch', img: '/img/languages/de.png' },
          // { value: 'es', name: 'Español', img: '/img/languages/es.png' },
        ],
        isTranslating : false,
        isHovered: false,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.autoResize(); // เรียกตอน mount
      });
    },
    computed  : {
      availableLanguages() {
        if (!Array.isArray(this.translations)) {
          return this.languages; // Return all languages if translations are undefined or not an array
        }
        return this.languages.filter(lang => !this.translations.some(sel => sel.value === lang.value));
      },
    },
    watch: {
      defaultDescription() {
          this.$nextTick(() => {
          this.autoResize();
        });
      },
      showModal(newVal) {
        this.localShowModal = newVal; // Sync prop with local data
      },
      localShowModal(newVal) {
        this.$emit('update:showModal', newVal); // Emit event when local data changes
        if (newVal) {
          this.$nextTick(() => {
            this.autoResize(); // resize defaultDescTextarea

            // resize translations
            this.translations.forEach((t, index) => {
              const refKey = 'descTextarea-' + index;
              const textarea = this.$refs[refKey];
              const el = Array.isArray(textarea) ? textarea[0] : textarea;
              this.resizeTextarea(el);
            });
          });
        }
      }
    },
    methods: {
      onSelectLanguage(lang) {
        if (!lang) return;
        this.$emit('addLanguage', lang);
        // เคลียร์ค่าเพื่อให้เลือกต่อได้ง่าย
        this.$nextTick(() => this.$refs.langSelect && this.$refs.langSelect.clear());
      },
      isRTL(lang) {
        return ['ar', 'he', 'fa', 'ur'].includes(lang);
      },
      getLangString() {
        return this.translations
          .map(t => t.value)
          .filter(Boolean)
          .join(',');
      },
      async animateDescription(targetInput, text) {
        targetInput.isAnimating = true;
        targetInput.description = '';
        const words = text.split(' ');

        for (let i = 0; i < words.length; i++) {
          targetInput.description += words[i] + ' ';
          await new Promise(resolve => setTimeout(resolve, 120)); // สามารถปรับความเร็วได้
        }
        targetInput.isAnimating = false;
        this.$forceUpdate()
      },
      getTranslationAll(){
        this.isTranslating = true;
        this.loadingButton = false;
        const shopObjectId = this.shopObjectId;
        const headers = {shopObjectId: util.sanitizeShopObjectId(shopObjectId)}

        const data = {
          text: this.defaultDescription,
          to: this.getLangString()
        };

        openrouter({
          url: '/api/translate/translatemulti',
          headers,
          data,
          method: 'POST',
        })
          .then((res) => {
            const serverResults = res.data?.data?.translations || {}; // สำหรับ standardized response
            this.languages.forEach((lang) => {
            const translatedText = serverResults[lang.value] || '';
            const existing = this.translations.find(t => t.value === lang.value);

            if (existing) {
                this.$set(existing, 'description', translatedText || existing.description);
              } 
            });
          })
          .catch((err) => {
            console.error('❌ Translation error:', err);
            this.loadingButton = true;
          })
          .finally(() => {
            this.isTranslating = false;
            this.translations.forEach(t => t.loading = false);
          });
      },
      getTranslation(index) {
        const input = this.translations[index];
        input.loading = true;
        this.loadingButton = false;
        input.loading = true;
        const shopObjectId = this.shopObjectId;
        const headers = {shopObjectId: util.sanitizeShopObjectId(shopObjectId)}

        const data = {
          text: this.defaultDescription,
          to : input.value
        };

        openrouter({
          url: '/api/translate/check',
          headers,
          data,
          method: 'POST',
        })
          .then((res) => {
            const serverResults = res.data?.data?.translated || ""; // สำหรับ standardized response
            this.animateDescription(input, serverResults);
            this.loadingButton = true;
          })
          .catch((err) => {
            console.error('❌ Translation error:', err);
            this.loadingButton = true;
          })
          .finally(() => {
            input.loading = false;
          });
      },
      addLanguage() {
        if (this.newLanguage) {
          this.$emit('addLanguage', this.newLanguage);
          this.newLanguage = '';
        }
      },
      focusLanguageSelect() {
        this.$refs.languageSelect.toggleDropdown();
      },
      removeLanguage(index) {
        this.$emit('removeLanguage', index);
      },
      handleCheckboxChange(input) {
        if (input.isTheSame) {
          input.description = this.defaultDescription
        } else {
          input.description = ''
        }
      },
      resizeTextarea(el, lineCount = 5) {
        if (!el) return;

        el.style.height = 'auto';
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 24;
        const minHeight = lineHeight * lineCount;
        el.style.height = Math.max(el.scrollHeight, minHeight) + 'px';
      },
      autoResize() {
        this.$nextTick(() => {
          const el = this.$refs.defaultDescTextarea;
          this.resizeTextarea(el);
        });
      },
      autoResizeFromInput(event, index) {
        this.$nextTick(() => {
          const refKey = 'descTextarea-' + index;
          const textarea = this.$refs[refKey];
          const el = Array.isArray(textarea) ? textarea[0] : textarea;
          this.resizeTextarea(el);
        });
      },
    }
  };
</script>
  
<style>
  .lang-icon {
    padding-left: 5px;
    padding-top: 5px;
    align-items: unset;
    width: 42px;
    height: auto;
  }

 
  .ai-icon {
    position: absolute;
    right: 50px;
    padding-bottom: 35px;
    transform: translateY(-50%);
    color: #3182ce;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 3;
  }

  .text-ai {
    margin-left: 2px;
  }
  .spinning {
    animation: spin 1s linear infinite ;
    display: inline-block; 
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  

  @keyframes softBlink {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.5; }
  }

  @keyframes shake {
    0% { transform: translate(0px, 0px); }
    25% { transform: translate(2px, 0px); }
    50% { transform: translate(-2px, 0px); }
    75% { transform: translate(2px, 0px); }
    100% { transform: translate(0px, 0px); }
  }
  .soft-blink {
    animation: softBlink 1.5s ease-in-out infinite;
    transition: opacity 0.3s ease;
    animation-fill-mode: none;
    cursor: pointer;
  }
  .no-blink {
    animation: none;
    cursor: pointer;
  }
  .shake-on-hover:hover {
    animation: shake 0.4s;
  }
  .card-body-background {
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: 300px;
  /* background-image: url('/img/languages/a1.png'); */
  background-image: url('/img/languages/Translate-BY-AI_W02.jpg');
}

.card-body-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%; /* 🔁 เปลี่ยนจาก bottom: 0 เป็น height: 100% */
  background-color: rgba(255, 255, 255, 0.90);
  z-index: 1;
  pointer-events: none; /* ✅ ให้คลิกผ่านได้ */
}

.card-body-background > * {
  position: relative;
  z-index: 2;
}
.light-background::before {
  background-color: rgba(255, 255, 255, 0.6); /* ปรับความโปร่งใสเบาลง */
}
.scrollable-translations {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px; /* ป้องกันไม่ให้ scrollbar ทับเนื้อหา */
}
.lang-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lang-flag {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 0 1px rgba(0,0,0,.35);
}
</style>
  